// ----------------------------------------------------------------------- imports externos
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// ----------------------------------------------------------------------- imports internos
import { useAuth } from "../auth/AuthContext";
import Marca from "../components/Marca";
import CampoClave from "../components/funcionales/CampoClave";

const CambiarPassword = () => {
  const { cambiarPassword, fullUser } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      Swal.fire({
        title: "Contraseña muy corta",
        text: "Tiene que tener al menos 8 caracteres.",
        icon: "warning",
        confirmButtonText: "Entendido",
        confirmButtonColor: "var(--acc, #4161bd)",
      });
      return;
    }

    if (password !== confirmar) {
      Swal.fire({
        title: "No coinciden",
        text: "Las dos contraseñas tienen que ser iguales.",
        icon: "warning",
        confirmButtonText: "Entendido",
        confirmButtonColor: "var(--acc, #4161bd)",
      });
      return;
    }

    setLoading(true);
    try {
      await cambiarPassword(password);
      Swal.fire({
        title: "Listo",
        text: "Tu contraseña fue actualizada.",
        icon: "success",
        confirmButtonText: "Entendido",
        confirmButtonColor: "var(--acc, #4161bd)",
      });
      navigate("/", { replace: true });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo actualizar la contraseña.",
        icon: "error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "var(--acc, #4161bd)",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <Marca />
      <div className="login-screen__panel">
        <div className="login-card">
          <h2>Definí tu contraseña</h2>
          <p className="login-card__subtitle">
            {fullUser?.nombres ? `Hola ${fullUser.nombres}, ` : ""}
            es la primera vez que entrás — elegí una contraseña nueva, propia.
          </p>
          <form onSubmit={handleSubmit}>
            <label className="field-label" htmlFor="nueva-password">
              Nueva contraseña
            </label>
            <CampoClave
              id="nueva-password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label className="field-label" htmlFor="confirmar-password">
              Repetir contraseña
            </label>
            <CampoClave
              id="confirmar-password"
              placeholder="••••••••"
              value={confirmar}
              onChange={(e) => setConfirmar(e.target.value)}
              required
            />
            <button
              type="submit"
              className="btn btn--primary btn--block"
              disabled={loading}
            >
              {loading ? "Guardando..." : "Guardar y entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CambiarPassword;
